import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-float-menu",
  templateUrl: "./float-menu.component.html",
  styleUrls: ["./float-menu.component.scss"],
})
export class FloatMenuComponent {
  @Input() modelCar = {
    index: 0
  };
  @Output() model = new EventEmitter();
  setModel(index: number) {
    this.model.emit(index);
    
  }

  logoTunlandG9 = "assets/img/LogoTunlandG9.webp";
  logoTunlandG7 = "assets/img/LogoTunlandG7.webp";
}
